import { Outlet } from 'react-router-dom';
import './Layout.css';
import Header from '../header/Header';
import Footer from '../footer/Footer';

function Layout() {
  return (
    <div className="layout">
      <Header />

      <main className="mainContent">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
